import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot && !a.isTop).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-fire-line text-primary-500 text-xl"></i>
          </div>
          <h2 className="text-lg font-heading font-bold text-foreground-200">
            热门爆料
          </h2>
        </div>
        <Link
          to="/category/hot-trending"
          className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {hotArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-100 border border-background-300/60 rounded-xl overflow-hidden hover:border-primary-500/40 transition-all cursor-pointer"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                  HOT
                </span>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2 leading-relaxed">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-600 whitespace-nowrap">
                  <i className="ri-time-line mr-1"></i>{article.publishedAt}
                </span>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-foreground-600 whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万
                  </span>
                  <span className="text-xs text-foreground-600 whitespace-nowrap">
                    <i className="ri-chat-3-line mr-1"></i>{article.comments}
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}